import {SuperDoctorThunks} from '../Redcuers/SuperDoctor';
import {getLanguage} from '../Redcuers/LanguageSlice';

const AsyncThunks = {
  getLanguage,
  ...SuperDoctorThunks,
};

export default AsyncThunks;
